"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _common;
var _default = exports.default = {
  common: (_common = {
    cancel: '取消',
    save: '保存',
    close: '关闭',
    confirm: '确认',
    complete: '完成',
    back: '返回',
    submit: '提交',
    search: '搜索',
    reset: '重置',
    add: '新增',
    create: '新增',
    check: '查看',
    checkin: '签到',
    auth: '授权',
    edit: '编辑',
    checkResult: '查看结果',
    saveErrorMessage: '保存失败',
    exportResult: '结果导出',
    errorInfo: '错误原因',
    viewParam: '通道参数',
    viewAccount: '通道账户',
    datetimeSearch: '时间查找',
    to: '至',
    startDatetime: '开始时间',
    EndDatetime: '结束时间',
    selectDatetime: '选择日期',
    delete: '删除',
    DELETED: '删除',
    modifyPass: '修改密码',
    roleAuth: '角色授权',
    distributeAuth: '分配权限',
    checkAuthDetail: '权限明细',
    checkDetail: '查看详情',
    enable: '启用',
    enabled: '启用',
    disabled: '禁用',
    locked: '锁定',
    ENABLE: '启用',
    DISABLED: '禁用',
    ENABLED: '启用',
    LOCKED: '锁定',
    more: '更多',
    tip: '提示',
    enableSuccess: '启用成功',
    enableFail: '启用失败',
    disableSuccess: '禁用成功',
    disableFail: '禁用失败',
    disabledSuccess: '禁用成功',
    disabledFail: '禁用失败',
    authSuccess: '授权成功',
    authFail: '授权失败',
    saveSuccess: '保存成功',
    saveDraftSuccess: '保存草稿成功',
    updateSuccess: '更新成功',
    deleteSuccess: '删除成功',
    resetSuccess: '重置成功',
    checkinSuccess: '签到成功',
    uploadSuccess: '上传成功',
    uploadError: '上传失败',
    confirm1: '确认要删除吗?',
    confirm2: '确认要禁用此菜单吗?',
    confirm3: '确认要启用此菜单吗?',
    confirm4: '确认要删除此菜单吗?',
    confirm5: '确认要禁止吗?',
    confirm6: '确认要开启吗?',
    confirm7: '确认要重置凭证吗?',
    confirm8: '确认要禁用此用户吗?',
    confirm9: '确认要启用此用户吗?',
    confirm10: '确认要删除此用户吗?',
    confirm11: '有修改项未保存，确认关闭？',
    confirm12: '确认要重置该用户密码吗?',
    confirm13: '确认要修改密码吗?',
    confirm14: '确认要保存修改吗?',
    preciseQuery: '精确查询',
    fuzzyQuery: '模糊查询',
    resetToken: '重置凭证',
    export: '导出',
    exportCarSubsidy: '车补行程单',
    exportMealSupplement: '餐补统计',
    exportDetail: '导出明细',
    exportAll: '导出全部历史记录',
    print: '打印',
    preview: '预览',
    import: '导入',
    resetFile: '重新选择文件',
    pleaseInput: '请输入',
    pleaseSelect: '请选择',
    pleaseSelectOrInput: '请选择或输入',
    previousStep: '上一步',
    nextStep: '下一步'
  }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_common, "back", '上一步'), "next", '下一步'), "saveDraft", '保存草稿'), "clickUpload", '点击上传'), "switchLang", '语言切换成功'), "Monday", '星期一'), "Tuesday", '星期二'), "Wednesday", '星期三'), "Thursday", '星期四'), "Friday", '星期五'), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_common, "Saturday", '星期六'), "Sunday", '星期日'), "systemPk", '序号'), "year", '年'), "month", '月'), "day", '日'), "startDate", '开始日期'), "startTime", '开始时间'), "endDate", '结束日期'), "endTime", '结束时间'), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_common, "selectTimeRange", '选择时间区间'), "uploadLimit50M", '请上传小于50M的图片'), "uploadLimitDesc1", '请上传小于'), "uploadLimitDesc2", 'M的图片'), "uploadImage", '上传图片'), "dragImageHere", '或将文件拖到此处'), "exportReport", '导出报表'), "exportRange", '导出范围'), "execute", '执行'), "action", '操作'), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_common, "comment", '评价'), "send", '发送'), "total", '总计'), "list", '列表'), "brand", '品牌'), "year2", '年份'), "date", '日期'), "province", '省'), "city", '市'), "area", '区'), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_common, "paramError", '参数错误'), "errorInfo", '问题信息'), "yes", '是'), "no", '否'), "provinceCity", '省市')),
  /* route 默认小写 */
  route: {
    dashboard: '首页',
    errorPages: '错误页面',
    page401: '401',
    page404: '404',
    profile: '个人中心',
    functionmodule: '系统管理',
    sysconfig: '系统参数配置',
    business: '业务系统',
    lookup: '查找值管理',
    interfaceinfo: '接口信息管理',
    interfaceuser: '接口用户管理',
    role: '角色管理',
    sysuser: '系统用户管理',
    functionlist: '功能管理',
    menulist: '菜单管理',
    logmodule: '日志管理模块',
    apilog: '接口日志管理',
    calllog: '外调接口日志管理',
    loginlog: '登录日志管理',
    emailmodule: '邮件管理模块',
    emailconfig: '邮件服务器配置管理',
    emailtemplate: '邮件模板管理',
    smsmodule: '短信模块',
    smstemplate: '短信模板管理',
    smschannel: '短信通道管理',
    userclassification: '用户类型管理',
    doubleweekplan: '计划管理',
    storemodule: '零售商管理',
    cpstoremodule: '固铂零售商管理',
    srstorelist: '门店管理',
    cpstorelist: '固铂门店管理',
    dastorelist: '零售商与SR关系管理',
    planmodule: '计划管理',
    storevisitreport: '访店报告编制',
    taskschedulelog: '定时任务日志管理',
    taskassignmentmodule: '任务分配管理'
  },
  navbar: {
    dashboard: '首页',
    github: '项目地址',
    changeRole: '切换角色',
    changeRole_success: '角色切换成功',
    changeRole_fail: '角色切换失败',
    changeRole_noPermission: '请使用手机端以获取更好的用户体验',
    logOut: '退出登录',
    profile: '个人中心',
    theme: '换肤',
    size: '布局大小',
    system: '系统',
    taskList: '任务列表',
    likeCommentList: '点赞评论列表'
  },
  login: {
    title: '欢迎来到SFE管理后台',
    welcome: '欢迎登录',
    logIn: '登录',
    login: '登 录',
    ssoLogin: '使用企业账号登录',
    username: '账号',
    password: '密码',
    code: '验证码',
    remember: '记住密码',
    selectRole: '角色选择',
    selectRolePlaceholder: '请选择角色',
    backToLogin: '重新登录',
    enterSystem: '进入系统',
    redirectError: '登录凭证已失效，请重新登录',
    placeholder: {
      username: '请输入账号',
      password: '请输入密码',
      code: '请输入框中的验证码'
    },
    error: {
      username: '请输入合法的账号',
      password: '请输入合法的密码',
      code: '请输入正确的验证码'
    }
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  profile: {
    action: '用户操作'
  },
  settings: {
    title: '系统布局配置',
    theme: '主题色',
    tagsView: '开启 Tags-View',
    fixedHeader: '固定 Header',
    sidebarLogo: '侧边栏 Logo'
  },
  errorMsg: {
    400: '请求错误',
    401: '未授权，请登录',
    403: '拒绝访问',
    404: '请求地址出错',
    408: '请求超时',
    500: '服务器内部错误',
    501: '服务未实现',
    502: '网关错误',
    503: '服务不可用',
    504: '网关超时',
    505: 'HTTP版本不受支持',
    timeout: '连接超时，请重新尝试',
    loginFail: '登录失败'
  },
  errorValid: {
    formError: '请检查表单',
    empty: '请输入',
    emptyPhone: '请输入手机号',
    emptySelect: '请选择',
    emptyUpload: '请选择上传',
    validMultiFile: '上传数量超出限制，最多上传数量为',
    validPhone: '请输入合法的手机号码',
    validNumber: '请输入合法的数字',
    validText: '请输入合法的内容',
    validFloat: '请输入合法的数值',
    validPatt: '请输入合法的百分数,支持2位小数百分数',
    form: '请检查表单内容',
    startTime: '请选择开始时间',
    endTime: '请选择结束时间',
    emptyProject: '请至少勾选轮胎、非轮胎业务中的任意一项，如无，填写其他服务项注明'
  },
  MessageBox: {
    logOut: {
      title: '确认登出',
      content: '您已登出,您可以点击取消留在当前页面或者重新登入',
      confirm: '重新登录'
    }
  },
  Progress: {
    readData: '读取数据',
    checkHeader: '检查表头',
    checkData: '检查数据',
    importData: '导入数据',
    wait: '等待中',
    progress: '进行中',
    complete: '已完成',
    fail: '失败，请重试'
  },
  sysconfig: {
    BoxWrap: {
      manage: '配置查询',
      list: '配置列表'
    },
    input: {
      configType: '配置类型',
      configTypeHolder: '精确查询',
      configCode: '配置编码',
      configCodeHolder: '模糊查询'
    },
    table: {
      systemConfigPk: '序号',
      configType: '配置类型',
      configCode: '配置编码',
      configVal: '配置值',
      sequence: '排序',
      remark: '备注',
      action: '操作'
    },
    form: {
      configType: '配置类型',
      configCode: '配置编码',
      configVal: '配置值',
      sn: '排序',
      remark: '备注'
    },
    error: {
      configType: '请输入合法的配置类型',
      configCode: '请输入合法的配置编码',
      configVal: '请输入合法的配置值',
      sn: '请输入合法的数字'
    }
  },
  business: {
    BoxWrap: {
      manage: '业务系统管理',
      list: '系统列表'
    },
    table: {
      sequence: '序号',
      sysName: '系统名称',
      indexUrl: '首页URL',
      appIdentification: '应用标识',
      state: '状态',
      createName: '创建人',
      createTime: '创建时间',
      lastUpdateTime: '更新时间',
      action: '操作'
    },
    form: {
      sysName: '系统名称',
      indexUrl: '首页URL',
      sn: '排序',
      remark: '备注'
    },
    error: {
      sysName: '请输入合法的系统名称',
      indexUrl: '请输入合法的首页URL',
      sn: '请输入合法的数字'
    }
  },
  lookup: {
    BoxWrap: {
      manage: '查找值查询',
      list: '查找值列表'
    },
    input: {
      typeName: '类型名称',
      typeNameHolder: '精确查询',
      typeCode: '类型编码',
      typeCodeHolder: '模糊查询'
    },
    table: {
      sequence: '序号',
      typeName: '类型名称',
      typeCode: '类型编码',
      remark: '备注',
      action: '操作',
      valueCode: '查找值编码',
      valueName: '查找值名称',
      state: '状态'
    },
    dropdown: {
      view: '查看'
    },
    form: {
      typeName: '类型名称',
      typeCode: '类型编码',
      remark: '备注',
      action: '操作',
      searchCode: '查找值编码',
      searchName: '查找值名称',
      searchState: '查找值状态'
    },
    error: {
      typeName: '请输入合法的类型名称',
      typeCode: '请输入合法的类型编码',
      sn: '请输入合法的数字',
      valueName: '请输入合法的查找值名称',
      valueCode: '请输入合法的查找值编码'
    }
  },
  interfaceInfo: {
    BoxWrap: {
      manage: '接口查询',
      list: '接口列表'
    },
    input: {
      interfaceNo: '接口编号',
      interfaceNoHolder: '精确查询',
      interfaceName: '接口名称',
      interfaceNameHolder: '模糊查询'
    },
    table: {
      sequence: '序号',
      interfaceNo: '接口编号',
      interfaceName: '接口名称',
      state: '状态',
      remark: '备注',
      action: '操作'
    },
    form: {
      interfaceNo: '接口编号',
      interfaceName: '接口名称',
      interfaceType: '接口类型',
      remark: '备注'
    },
    error: {
      interfaceNo: '请输入合法的接口编号',
      interfaceName: '请输入合法的接口名称',
      interfaceType: '请输入合法的接口类型',
      sn: '请输入合法的数字'
    }
  },
  interfaceUser: {
    BoxWrap: {
      manage: '用户查询',
      list: '用户列表'
    },
    input: {
      interfaceUser: '接口用户',
      interfaceUserHolder: '接口用户'
    },
    dialog: {
      interfaceUserAuth: '接口用户授权',
      checkAuth: '查看凭证'
    },
    table: {
      sequence: '序号',
      userAuthVos: '授权接口信息',
      interfaceNo: '接口编号',
      interfaceName: '接口名称',
      state: '状态',
      userName: '用户名称',
      userType: '用户类型',
      loginCode: '登录编码',
      userMobile: '手机号码',
      createBy: '创建人',
      createTime: '创建时间',
      lastUpdateTime: '更新时间',
      action: '操作'
    },
    dropdown: {
      userAuth: '用户授权',
      viewToken: '查看凭证'
    },
    form: {
      authToken: '凭证Token',
      userName: '用户名称',
      loginCode: '登录编码',
      userMobile: '手机号码',
      remark: '备注'
    },
    error: {
      userName: '请输入合法的用户名称',
      loginCode: '请输入合法的登录名称',
      userMobile: '请输入合法的手机号',
      remark: '请输入合法的备注'
    }
  },
  role: {
    BoxWrap: {
      manage: '角色查询',
      list: '角色列表'
    },
    input: {
      roleName: '角色描述',
      roleNameHolder: '精确查询',
      roleCode: '角色名称',
      roleCodeHolder: '模糊查询'
    },
    table: {
      sequence: '序号',
      roleName: '角色描述',
      roleCode: '角色名称',
      createTime: '创建日期',
      createName: '创建人',
      menuName: '菜单名称',
      functionList: '功能列表',
      action: '操作'
    },
    dropdown: {
      checkAuthDetail: '权限明细',
      roleAuth: '分配权限',
      deleteItem: '删除'
    },
    form: {
      roleName: '角色描述',
      roleCode: '角色名称',
      remark: '备注'
    },
    error: {
      roleName: '请输入合法的角色描述',
      roleCode: '请输入合法的角色名称',
      sn: '请输入合法的数字'
    }
  },
  sysUser: {
    BoxWrap: {
      manage: '用户查询',
      list: '用户列表'
    },
    input: {
      userName: '用户姓名',
      userNameHolder: '精确查询',
      userClassification: '用户分组',
      userClassificationHolder: '请下拉选择',
      employeeNumber: '工号',
      phoneNumber: '手机号',
      email: '邮箱',
      isApply: '是否应用',
      role: '角色'
    },
    table: {
      sequence: '序号',
      employeeNumber: '工号',
      userName: '用户姓名',
      role: '角色',
      phone: '手机号',
      email: '邮箱',
      isApply: '是否启用',
      action: '操作',
      loginCode: '登录编码',
      loginModule: '登录模式',
      userClassification: '用户分组',
      extOne: '承运商',
      userMobile: '手机号码',
      state: '状态',
      createName: '创建人',
      createTime: '创建时间',
      lastUpdateTime: '更新时间',
      remark: '备注',
      roleName: '角色名'
    },
    dropdown: {
      resetPassword: '重置密码',
      modifyPassword: '密码修改',
      checkAuthDetail: '权限明细',
      roleAuth: '角色授权',
      deleteItem: '删除'
    },
    form: {
      select: '请选择',
      loginCode: '登录编码',
      loginModule: '登录模式',
      userClassification: '用户分组',
      extOne: '承运商',
      userName: '用户名称',
      userMobile: '手机号码',
      userEmail: '邮箱',
      remark: '备注',
      oldPassword: '原密码',
      newPassword: '新密码',
      confirmPassword: '确认密码'
    },
    error: {
      loginCode: '请输入合法的登录名称',
      loginModule: '请选择合法的登录模式',
      userClassification: '请选择合法的用户分组',
      extOne: '请选择承运商',
      userName: '请输入合法的用户名称',
      userMobile: '请输入合法的手机号',
      userEmail: '请输入合法的邮箱地址',
      sn: '请输入合法的数字',
      oldPassword: '请输入合法的原始密码',
      newPassword: '请输入合法的新密码',
      confirmPassword: '确认密码与新密码不一致'
    }
  },
  functionList: {
    BoxWrap: {
      list: '功能列表'
    },
    table: {
      sequence: '序号',
      menuName: '菜单名称',
      functionList: '功能列表',
      functionName: '功能名称',
      functionCode: '功能编码',
      functionBindNos: '关联接口',
      state: '状态',
      functionListAction: '操作',
      action: '操作'
    },
    form: {
      functionName: '功能名称',
      functionCode: '功能编码',
      functionBindNos: '关联接口',
      remark: '备注'
    },
    error: {
      functionName: '请输入合法的功能名称',
      functionCode: '请输入合法的功能编码',
      functionBindNos: '请输入合法的关联接口',
      sn: '请输入合法的数字'
    }
  },
  menuList: {
    BoxWrap: {
      manage: '菜单管理',
      list: '菜单列表'
    },
    table: {
      sequence: '序号',
      menuName: '菜单名称',
      menuCode: '菜单编码',
      menuUrl: '菜单URL',
      isTop: '置顶',
      isVirtual: '菜单类型',
      state: '状态',
      createTime: '创建时间',
      action: '操作'
    },
    form: {
      yes: '是',
      no: '否',
      N: '菜单',
      V: '虚拟菜单',
      R: '路由菜单',
      parentMenuName: '父菜单',
      menuName: '菜单名称',
      menuCode: '菜单编码',
      menuUrl: '菜单URL',
      menuIcon: '菜单图标',
      component: '菜单组件',
      isTop: '置顶',
      isVirtual: '菜单类型',
      sn: '排序',
      remark: '备注'
    },
    error: {
      menuName: '请输入合法的菜单名称',
      menuCode: '请输入合法的菜单编码',
      menuUrl: '请输入合法的菜单URL',
      menuIcon: '请输入合法的菜单Icon',
      component: '请输入合法的菜单组件',
      remark: '请输入合法的备注',
      sn: '请输入合法的数字'
    }
  },
  callLog: {
    BoxWrap: {
      manage: '日志查询',
      list: '日志列表'
    },
    input: {
      interfaceSn: '接口编号',
      interfaceSnHolder: '精确查询',
      errorCode: '错误码',
      errorCodeHolder: '精确查询',
      detailErrorCode: '明细错误码',
      detailErrorCodeHolder: '精确查询',
      startTime: '开始时间',
      startTimeHolder: '选择日期',
      endTime: '结束时间',
      endTimeHolder: '选择日期',
      systemSuffix: '日志表名'
    },
    table: {
      systemPk: '序号',
      interfaceSn: '接口编号',
      url: 'URL',
      errorCode: '错误码',
      detailErrorCode: '明细错误码',
      loginCode: '登录编码',
      ipAddr: 'IP',
      consumeTime: '耗时(ms)'
    },
    form: {
      systemPk: '序号',
      externalLogPk: '外调接口序号',
      perms: '所有者',
      interfaceSn: '接口编号',
      url: 'URL',
      requestMethod: '请求方式',
      errorCode: '错误码',
      detailErrorCode: '明细错误码',
      extAttr1: '额外内容1',
      extAttr2: '额外内容2',
      extAttr3: '额外内容3',
      extAttr4: '额外内容4',
      loginCode: '登录编码',
      ipAddr: 'IP',
      interfaceParamJson: '路径入参',
      interfaceResponseJson: '返回数据',
      reqTime: '访问时间',
      userAgent: '用户代理',
      consumeTime: '耗时(ms)'
    }
  },
  loginLog: {
    BoxWrap: {
      manage: '日志查询',
      list: '日志列表'
    },
    input: {
      loginCode: '登录编码',
      loginCodeHolder: '精确查询',
      ipAddr: 'IP地址',
      ipAddrHolder: '模糊查询',
      startTime: '开始时间',
      startTimeHolder: '选择日期',
      endTime: '结束时间',
      endTimeHolder: '选择日期'
    },
    table: {
      systemPk: '序号',
      sessionid: 'Sessionid',
      loginInDatetime: '登入时间',
      loginOutDatetime: '登出时间',
      loginCode: '登录编码',
      ipAddr: 'IP',
      loginLogPk: '日志编号',
      userPk: '用户编号',
      unionid: 'UnionId',
      remark: '备注',
      extAttr: '状态'
    }
  },
  apiLog: {
    BoxWrap: {
      manage: '日志查询',
      list: '日志列表'
    },
    input: {
      interfaceSn: '接口编号',
      interfaceSnHolder: '精确查询',
      errorCode: '错误码',
      errorCodeHolder: '精确查询',
      detailErrorCode: '明细错误码',
      detailErrorCodeHolder: '精确查询',
      systemSuffix: '日志表名'
    },
    table: {
      sequence: '序号',
      interfaceSn: '接口编号',
      loginCode: '登录编码',
      errorCode: '错误码',
      detailErrorCode: '明细错误码',
      ipAddr: 'IP',
      url: 'URL',
      consumeTime: '耗时(ms)',
      action: '操作'
    },
    form: {
      systemPk: '序号',
      interfaceLogPk: '接口序号',
      perms: '所有者',
      startTime: '开始时间',
      endTime: '结束时间',
      interfaceSn: '接口编号',
      url: 'URL',
      fullUrl: '完整URL',
      urlPattern: 'URL规范',
      referer: '引用',
      requestMethod: '请求方式',
      errorCode: '错误码',
      detailErrorCode: '明细错误码',
      extAttr1: '额外内容1',
      extAttr2: '额外内容2',
      extAttr3: '额外内容3',
      extAttr4: '额外内容4',
      queryString: '查找关键字',
      token: 'Token',
      ipAddr: 'IP',
      pathVariable: '路径入参',
      reqTime: '访问时间',
      consumeTime: '耗时(ms)',
      interfaceParamJson: '接口参数',
      interfaceResponseJson: '返回数据',
      loginCode: '登录编码',
      userAgent: '用户代理',
      sessionId: 'Session Id'
    }
  },
  emailConfig: {
    BoxWrap: {
      manage: '配置查询',
      list: '配置列表'
    },
    input: {
      emailName: '邮件服务器名称',
      emailNameHolder: '精确查询',
      emailStatus: '邮件服务器状态',
      emailStatusHolder: '模糊查询',
      emailType: '邮件类型',
      emailTypeHolder: '模糊查询',
      emailGroup: '邮件服务器组',
      emailGroupHolder: '模糊查询'
    },
    table: {
      addAccount: '添加账号',
      sequence: '序号',
      emailName: '邮件服务器名称',
      emailType: '邮件类型',
      emailGroup: '邮件服务器组',
      emailSslEnable: 'SSL',
      emailStatus: '服务器状态',
      accountStatus: '账号状态',
      senderNickname: '发送人昵称',
      senderAccount: '发送人账号',
      sendCountLimit: '最大发送数量',
      action: '操作'
    },
    form: {
      select: '请选择',
      emailServerPk: '服务器编号',
      emailName: '服务器名称',
      emailType: '服务器类型',
      emailGroup: '所属分组',
      emailHost: '域名',
      emailPort: '端口号',
      emailSslEnable: 'SSL',
      emailStatus: '状态',
      sendCountLimit: '最大发送数量',
      accountStatus: '帐号状态',
      emailAccountPk: '账号编号',
      sendCountUnit: '发送单位',
      senderAccount: '发送账号',
      senderNickname: '发送昵称',
      senderPassword: '发送密码',
      sort: '排序',
      remark: '备注'
    },
    error: {
      deleteAccount: '服务器下至少需要一个账号',
      accountStatus: '请输入合法的账户状态',
      emailPort: '请输入合法的端口',
      emailName: '请输入合法的邮件服务器名称',
      emailGroup: '请输入合法的邮件服务器组',
      emailHost: '请输入合法的域名',
      sendCountLimit: '请输入合法的最大发送数量',
      emailServerPk: '请输入合法的排序',
      emailSslEnable: '请输入合法的SSL状态',
      emailStatus: '请输入合法的服务器状态',
      emailType: '请输入合法的邮件类型',
      sendCountUnit: '请输入合法的发送单位(D/M)',
      senderAccount: '请输入合法的发送账号',
      senderNickname: '请输入合法的发送昵称',
      senderPassword: '请输入合法的发送密码',
      remark: '请输入合法的备注'
    }
  },
  emailTemplate: {
    BoxWrap: {
      manage: '模板查询',
      list: '模板列表'
    },
    input: {
      templateName: '模板名称',
      templateNameHolder: '精确查询'
    },
    table: {
      sequence: '序号',
      templateName: '模板名称',
      templateContextType: '模板类型',
      emailTemplateType: '所属分组',
      emailTemplatePk: '模板编号',
      createName: '创建人',
      createTime: '创建时间',
      remark: '备注',
      action: '操作'
    },
    form: {
      testSend: '测试发送',
      inputReciever: '收件邮箱',
      file: '选择模板文件',
      templateName: '模板名称',
      emailTemplateType: '所属分组',
      templateContextType: '模板类型',
      templateContext: '模板文本',
      select: '请选择',
      emailTemplatePk: '模板编号',
      sort: '排序',
      remark: '备注',
      emailConfigId: '邮件服务器',
      toAddresses: '收件人邮箱',
      emailTopic: '主题',
      emailAccountPk: '发送账号',
      emailContent: '邮件内容'
    },
    error: {
      inputReciever: '请输入合法的收件人邮箱',
      file: '请选择合法的文件',
      templateName: '请输入合法的模板名称',
      emailTemplateType: '请输入合法的所属分组',
      templateContextType: '请输入合法的模板类型',
      templateContext: '请输入合法的模板文本',
      emailTemplatePk: '请输入合法的模板编号',
      remark: '请输入合法的备注',
      emailConfigId: '请输入合法的邮件服务器编号',
      toAddresses: '请输入合法的收件人',
      emailTopic: '请输入合法的邮件主题',
      emailContent: '请输入合法的邮件内容'
    }
  },
  smsTemplate: {
    BoxWrap: {
      manage: '模板管理',
      list: '模板列表'
    },
    table: {
      sequence: '序号',
      templateName: '模板名称',
      templateType: '模板类型',
      templateCode: '模板编码',
      classification: '所属分组',
      isDeleted: '状态',
      createName: '创建人',
      createTime: '创建时间',
      content: '模板内容',
      action: '操作'
    },
    form: {
      select: '请选择',
      testSend: '测试发送',
      templateName: '模板名称',
      templateType: '模板类型',
      templateCode: '模板编码',
      smsTemplatePk: '模板编号',
      content: '模板内容',
      channelId: '通道名称',
      channelAccount: '通道账户',
      mobile: '手机号',
      templateParam: '模板参数'
    },
    error: {
      smsTemplatePk: '请输入合法的模板编号',
      templateName: '请选择合法的模板名称',
      templateCode: '请输入合法的模板编码',
      templateType: '请输入合法的模板类型',
      content: '请输入合法的模板内容',
      channelId: '请输入合法的通道名称',
      channelAccount: '请输入合法的通道账户',
      mobile: '请输入合法的手机号',
      templateParam: '请输入合法的模板参数'
    }
  },
  smsChannel: {
    BoxWrap: {
      manage: '通道查询',
      list: '通道列表'
    },
    input: {
      channelName: '通道名称',
      channelNameHolder: '精确查询',
      channelCode: '通道编码',
      channelCodeHolder: '精确查询',
      callMethod: '调用方式',
      callMethodHolder: '模糊查询',
      channelUsage: '通道用途',
      channelUsageHolder: '模糊查询'
    },
    table: {
      sequence: '序号',
      channelName: '通道名称',
      channelCode: '通道编码',
      channelAddress: '通道访问地址',
      callMethod: '调用方式',
      channelUsage: '通道用途',
      isDeleted: '状态',
      classification: '所属分组',
      createName: '创建人',
      createTime: '创建时间',
      action: '操作',
      paramName: '参数名称',
      paramKey: '参数键名',
      paramValue: '参数值',
      paramTransport: '传输方式',
      smsChannelAccountOwer: '账户归属名称',
      accountAppid: '账户标识',
      accountSecretkey: '账号密钥'
    },
    dropdown: {
      viewParam: '通道参数',
      viewAccount: '通道账户'
    },
    form: {
      select: '请选择',
      channelName: '通道名称',
      channelCode: '通道编码',
      callMethod: '调用方式',
      channelUsage: '通道用途',
      smsChannelPk: '通道编号',
      remark: '备注',
      paramName: '参数名称',
      paramKey: '参数键名',
      paramValue: '参数值',
      paramTransport: '传输方式',
      smsChannelAccountOwer: '账户归属名称',
      accountAppid: '账户标识',
      accountSecretkey: '账号密钥'
    },
    error: {
      channelName: '请输入合法的通道名称',
      channelCode: '请输入合法的通道编码',
      callMethod: '请输入合法的调用方式',
      channelUsage: '请输入合法的通道用途',
      smsChannelPk: '请输入合法的通道编号',
      paramName: '请输入合法的参数名称',
      paramKey: '请输入合法的参数键名',
      paramValue: '请输入合法的参数值',
      paramTransport: '请输入合法的传输方式',
      smsChannelAccountOwer: '请输入合法的账户归属名称',
      accountAppid: '请输入合法的账户标识',
      accountSecretkey: '请输入合法的账号密钥'
    }
  },
  userClassification: {
    BoxWrap: {
      manage: '用户类型管理',
      list: '用户类型列表'
    },
    input: {
      clfName: '类型名称',
      clfNameHolder: '模糊查询',
      clfCode: '类型编码',
      clfCodeHolder: '模糊查询',
      dpExecutor: '执行器名称',
      dpExecutorHolder: '模糊查询',
      dpContent: '执行内容',
      dpContentHolder: '模糊查询',
      remark: '备注',
      remarkHolder: '模糊查询'
    },
    table: {
      sequence: '序号',
      clfName: '类型名称',
      clfCode: '类型编码',
      dpExecutor: '执行器名称',
      dpContent: '执行内容',
      remark: '备注',
      createName: '创建人',
      createTime: '创建时间',
      lastUpdateTime: '更新时间',
      action: '操作'
    },
    form: {
      clfName: '类型名称',
      clfCode: '类型编码',
      dpExecutor: '执行器名称',
      dpContent: '执行内容',
      remark: '备注'
    },
    error: {
      clfName: '类型名称不能为空且不能超过100字符',
      clfCode: '类型编码不能为空且不能超过100字符',
      dpExecutor: '执行器名称不能为空且不能超过100字符',
      dpContent: '执行内容不能为空',
      remark: '备注不能为空'
    }
  },
  // new content
  newLoginLog: {
    BoxWrap: {
      manage: '登录日志查询',
      list: '登录日志列表'
    },
    input: {
      inputHolder: '请输入',
      loginAccount: '登录账号',
      loginInStyle: '状态',
      empNo: '工号',
      time: '登入日期',
      timeHolder: '请选择日期',
      optionHolder: '请选择'
    },
    table: {
      systemPk: '序号',
      logNo: '日志编号',
      employeeNumber: '工号',
      loginTerminal: '登录终端',
      username: '登录账号',
      loginTime: '登入时间',
      loginOutTime: '登出时间',
      status: '状态'
    },
    btn: {
      export: '导出',
      exportText: '登录日志'
    }
  },
  configuration: {
    common: {
      ENABLED: '启用',
      DISABLED: '禁用',
      configurationValue: '值配置',
      addValue: '新增'
    },
    BoxWrap: {
      manage: '配置管理',
      list: '配置列表'
    },
    input: {
      holder: '请输入',
      fieldCode: '字段编码',
      directions: '说明',
      configItemName: '字段名称',
      configurationType: '配置类型',
      enableStatus: '启用状态',
      optionHolder: '请选择'
    },
    form: {
      code: '编码',
      fieldCode: '字段编码',
      configItemName: '字段名称',
      remark: '备注',
      value: '值'
    },
    table: {
      systemPk: '序号',
      fieldCode: '字段编码',
      configItemName: '字段名称',
      configurationType: '配置类型',
      configurationValues: '配置值',
      sort: '排序',
      enableStatus: '启用状态',
      enableTime: '启用时间',
      action: '操作'
    },
    error: {
      configItemName: '请输入合法的值',
      itemDetailCode: '请输入合法的值',
      itemIsMember: '请输入合法的数值',
      isNotValueEmpty: '数值不能为空',
      valueCN: '请输入合法的值',
      valueEN: '请输入合法的值',
      repeat: '新增值已存在'
    }
  },
  messagePush: {
    BoxWrap: {
      manage: '消息推送查询',
      list: '消息推送列表'
    },
    common: {
      S: '成功',
      F: '失败',
      resultStatus: {
        STORE_VISIT_FOLLOWED: '访店待跟进事项',
        STORE_REGISTER: '新注册门店',
        ORDER_STATUS_CHANGE: '订单状态变更'
      },
      batchPush: '批量重推'
    },
    input: {
      inputHolder: '请输入',
      pushContent: '推送内容',
      pusher: '接收人',
      pusherEmail: '接收人邮箱',
      pusherStatus: '推送状态',
      messageType: '消息类型',
      time: '推送日期',
      timeHolder: '请选择日期',
      optionHolder: '请选择'
    },
    table: {
      systemPk: '序号',
      pusher: '接收人',
      pusherPhone: '接收人手机号',
      pusherEmail: '接收人邮箱',
      messageType: '消息类型',
      pushContent: '推送内容',
      pushStatus: '推送状态',
      pushDate: '推送时间',
      action: '操作',
      rePush: '重推'
    },
    message: {
      errorTips: '请选择需要推送的消息',
      confirmTips: '确认要重推吗?'
    }
  },
  district: {
    BoxWrap: {
      manage: '省市区管理',
      list: '省市区列表'
    },
    input: {},
    table: {
      province: '省',
      city: '市',
      area: '区'
    }
  },
  organizationArchitecture: {
    BoxWrap: {
      list: '业务组织架构查询'
    },
    btn: {
      import: '导入',
      export: '导出',
      resetFile: '重新选择文件',
      exportText: '业务组织架构'
    },
    table: {
      sequence: '序号',
      role: '角色',
      architectureLevel: '结构级别',
      name: '姓名',
      employeeNumber: '工号',
      type: '团队类型',
      email: '邮箱',
      parentEmpNo: '上级工号',
      parentEmpName: '上级姓名'
    }
  },
  salesArea: {
    BoxWrap: {
      manage: '销售区域查询',
      list: '销售区域列表'
    },
    input: {
      iptholder: '请输入',
      province: '省',
      city: '市',
      area: '区',
      empNo: '工号',
      empName: '姓名',
      email: '邮箱',
      cascaderPlaceholder: '请选择所在地区'
    },
    btn: {
      import: '导入',
      export: '导出',
      exportText: '销售区域',
      exportRegion: '省市区导出',
      exportRegionText: '省市区',
      resetFile: '重新选择文件',
      syncData: '更新门店SR'
    },
    table: {
      systemPk: '序号',
      province: '省/直辖市',
      city: '市',
      district: '区/县',
      empNo: '工号',
      empName: '姓名'
    },
    message: {
      syncSuccess: '同步成功',
      syncFail: '同步失败'
    }
  },
  material: {
    BoxWrap: {
      manage: '产品查询',
      list: '产品列表'
    },
    input: {
      inputHolder: '请输入',
      materialCode: '产品编号',
      materialDescription: '产品描述',
      materialInnerStatus: '停售状态',
      brand: '品牌',
      optionPlaceholder: '请选择'
    },
    table: {
      materialCode: '产品编号',
      materialDescription: '产品描述',
      offshelf: '停售状态',
      brand: '品牌',
      tyreSize: '轮胎尺寸',
      pattern: '花纹',
      ROFType: 'ROF类型',
      action: '操作'
    }
  },
  serviceProvider: {
    BoxWrap: {
      manage: '服务商信息查询',
      list: '服务商列表'
    },
    input: {
      inputHolder: '请输入',
      serviceProviderCode: '服务商代码',
      serviceProviderName: '服务商名称',
      serviceProviderNameRegion: '服务商所在省市区',
      optionPlaceholder: '请选择'
    },
    table: {
      serviceProviderID: '服务商编号',
      serviceProviderName: '服务商名称',
      province: '省',
      city: '市',
      district: '区',
      serviceProviderAddress: '服务商地址',
      action: '操作'
    }
  },
  materialDetails: {
    BoxWrap: {
      manage: '产品管理'
    },
    header: {
      materialCode: '产品编号'
    },
    form: {
      title: '产品主数据',
      materialCode: 'SAP产品物料编号',
      materialDescription: '产品描述',
      brand: '品牌',
      language: '语言',
      rim: '轮辋直径',
      tyreSize: '轮胎尺寸',
      loadIndex: '载重指数',
      speedIndex: '速度级别',
      pattern: '花纹',
      rofType: '应用技术',
      oeMark: 'OE标识',
      sapOffshelf: '停售状态',
      countryOfOrigin: '产地国家',
      englishPatName: '花纹（英文）',
      vehicleType: '车辆类型',
      fitment: '典型适配车型'
    }
  },
  salesStatus: {
    BoxWrap: {
      manage: '销售情况',
      list: '销售情况列表'
    },
    column: {
      salesTotal: '轮胎月均总销量',
      stockTotal: '总库存'
    },
    table: {
      materialDescription: '轮胎品牌',
      tyreSize: '主要进货渠道',
      pattern: '结款方式',
      ROFType: '月均销量',
      action: '库存'
    }
  },
  doubleWeekPlan: {
    common: {
      selectHolder: '请选择',
      searchStore: '请输入门店ID、名称或地址',
      fillReport: '填写访店报告',
      backPlanlist: '返回计划列表',
      waitComp: '待完成'
    },
    title: {
      storeToVisit: '待访问门店',
      somethingElse: '其他事项',
      visitPurpose: '拜访目的',
      checkin: '签到',
      addStore: '新开卡',
      existingMatters: '时间冲突',
      checkinSuccess: '签到成功',
      checkMap: '查看地图',
      storePreview: '推荐访店路线预览',
      storeVisitAdvanced: '新建访店计划',
      editDate: '修改日期'
    },
    label: {
      conflict: '有冲突'
    },
    enum: {
      all: '全部',
      plan: '计划',
      task: '任务'
    },
    role: {
      addPlan: '新增计划',
      addTask: '新增任务',
      addStorePlan: '访店计划',
      addOtherPlan: '其他计划',
      addStoreTask: '访店任务',
      addOtherTask: '其他任务',
      editTarget: '填写目的',
      matterProcessing: '事项处理',
      viewReport: '查看报告',
      enote: '查看enote',
      fillReport: '进入访店流程',
      checkin: '签到',
      otherPlanFirst: '请优先创建其他计划',
      newStore: '新开卡'
    },
    BoxWrap: {
      manage: '计划管理',
      list: '计划列表',
      chooseStore: '门店选择'
    },
    step: {
      targetTheme: '目标主题',
      mainTheme: '门店选择 (主要主题)',
      otherTheme: '门店选择 (其他主题)',
      routePlan: '路线规划'
    },
    input: {
      dateRange: '起止日期',
      startTimeHolder: '请选择日期',
      endTimeHolder: '请选择日期',
      name: '姓名',
      id: '工号',
      srName: 'SR姓名',
      srCode: 'SR工号',
      inputHolder: '请输入',
      taskDate: '任务日期',
      taskType: '任务类型',
      startTime: '开始时间',
      endTime: '结束时间',
      customerName: '潜在客户名称',
      customerAddress: '潜在客户地址',
      desc: '简要说明',
      target1: '拜访目的1',
      target2: '拜访目的2',
      asmVisitPurpose: 'ASM拜访目的',
      asmVisitSummary: 'ASM访店总结',
      planDate: '拜访日期',
      planRangeTime: '拜访时间',
      TTPSigningVolume: '固特异TPP',
      storeContact: '门店联系人',
      category: '类型',
      collaborativeFlag: '协同访店',
      businessObjective: '当日拜访主题',
      visitTime: '拜访时间'
    },
    table: {
      date: '日期',
      status: '状态',
      startTime: '开始时间',
      endTime: '结束时间',
      matter: '事项',
      storeCode: '门店编号',
      storeName: '门店名称',
      srName: 'SR姓名',
      srCode: 'SR工号',
      action: '操作',
      PCD: '省市区',
      storeAddress: '门店地址',
      created: '已创建',
      unCreate: '未创建',
      category: '类型',
      retailerType: '零售店类别',
      rtlRtmCategory: 'RTM类型',
      contact: '联系人',
      contactor: '联系人',
      contactorPhone: '电话',
      collaborativeFlag: '协同访店',
      mainBusiness: '主营业务',
      storeBrand: '店招品牌',
      storeStatus: '门店状态',
      storeType: '门店类型',
      tppSales: 'TPP签约量',
      monthlySverageSales: '月均销量',
      otherInformation: '标签',
      rangeDiameter: '范围直径（基于主要主题）',
      firstVisitStore: '首访门店',
      endVisitStore: '结束门店',
      planRangeNo: '拜访顺序',
      planRangeTime: '拜访时间',
      backPreviousStep: '返回上一步',
      rePlanStoreVisits: '重新规划访店',
      confirmCreation: '确认创建',
      selectMainStore: '请选择主主题门店',
      selectFirstStore: '请选择首访门店',
      moreStoreRecommendations: '更多门店推荐',
      moreStoreRecommendationsFirst: '当前已选',
      moreStoreRecommendationsLast: '家门店，是否继续补充？',
      backPreviousStepTips: '返回上一步会清空您当前步骤所选择的的全部门店，您是否确定返回？',
      rePlanningTips: '在当前步骤重新规划会清空您所选择的全部门店，您是否确定重新规划访店？'
    },
    btn: {
      export: '导出',
      exportText: '计划管理'
    },
    error: {
      taskType: '请选择任务类型',
      storeName: '请输入门店名称',
      PCD: '请选择省市区',
      storeAddress: '请输入门店地址',
      storeChecked: '请选择门店',
      desc: '请输入简要说明',
      visitPurpose: '请选择访问目的',
      planDate: '请选择计划日期',
      planRangeTime: '请填写拜访时间',
      taskTarget: '请填写拜访目的相关信息',
      visitTime: '请选择时间'
    }
  },
  SRStoreList: {
    common: {
      addStore: '新开卡',
      selectHolder: '请选择',
      startTimeHolder: '开始时间',
      endTimeHolder: '结束时间',
      cascaderPlaceholder: '请选择所在地区',
      startMonthHolder: '开始月份',
      endMonthHolder: '结束月份',
      pleaseSelectMonth: '请选择月份范围'
    },
    export: {
      storeInfo: '门店基础信息',
      otherInfo: '销售情况',
      trainRecord: '培训记录',
      visitRecord: '访店记录',
      KPIData: '其他参考信息',
      storeLogoInfo: '门头照上传情况',
      feedback: '意向反馈情况'
    },
    BoxWrap: {
      manage: '门店查询',
      list: '门店列表'
    },
    btn: {
      import: '导入',
      export: '导出',
      resetFile: '重新选择文件'
    },
    form: {
      customerNumber: '客户编号',
      storeName: '店名',
      RTMType: 'RTM类型',
      retailStoreCategory: '零售店类别',
      provinceCityDistrict: '省市区',
      province: '省',
      city: '市',
      area: '区',
      address: '地址',
      SRNO: 'SR工号',
      SRName: 'SR姓名',
      storeContact: '门店联系人',
      lastPurchaseTime: '最近一次RTM下单时间',
      TTPSigningVolumeGY: '固特异TPP',
      TTPSigningVolumeCP: '固铂TPP',
      lastVisitTime: '最近一次拜访日期',
      shopBrandType: '店招品牌类型',
      visitFrequency: '当月拜访次数',
      rebateBalance: '返利结余',
      isBaiLian: '百炼转换',
      monthRange: '月份范围',
      visitTheme: '当日拜访主题'
    },
    table: {
      customerNumber: '客户编号',
      storeName: '店名',
      RTMType: 'RTM类型',
      retailStoreCategory: '零售店类别',
      province: '省',
      city: '市',
      area: '区',
      address: '地址',
      SRNO: 'SR工号',
      SRName: 'SR姓名',
      TTPSigningVolumeGY: '固特异TPP',
      TTPSigningVolumeCP: '固铂TPP',
      rebateBalance: '返利结余',
      lastPurchaseTime: '最近一次RTM下单时间',
      lastVisitTime: '最近一次拜访日期',
      visitFrequency: '当月拜访次数',
      contract: '是否参与天猫/京东',
      shopBrandType: '店招品牌类型',
      gasnFlag: 'GASN门店签约情况',
      pointBalance: '积分结余',
      storeContact: '联系人',
      action: '操作'
    }
  },
  CPStoreList: {
    common: {
      addStore: '新开卡',
      selectHolder: '请选择',
      startTimeHolder: '开始时间',
      endTimeHolder: '结束时间',
      cascaderPlaceholder: '请选择所在地区',
      startMonthHolder: '开始月份',
      endMonthHolder: '结束月份',
      pleaseSelectMonth: '请选择月份范围'
    },
    export: {
      storeInfo: '门店信息',
      visitReport: '拜访报告'
    },
    BoxWrap: {
      manage: '门店查询',
      list: '门店列表'
    },
    btn: {
      import: '导入',
      export: '导出',
      resetFile: '重新选择文件'
    },
    form: {
      customerNumber: '客户编号',
      storeName: '店名',
      RTMType: 'RTM类型',
      retailStoreCategory: '零售店类别',
      provinceCityDistrict: '省市区',
      province: '省',
      city: '市',
      area: '区',
      address: '地址',
      SRNO: 'SR工号',
      SRName: 'SR姓名',
      storeContact: '门店联系人',
      lastPurchaseTime: '最近一次RTM下单时间',
      TTPSigningVolumeGY: '固特异TPP',
      TTPSigningVolumeCP: '固铂TPP',
      lastVisitTime: '最近一次拜访日期',
      shopBrandType: '店招品牌类型',
      visitFrequency: '当月拜访次数',
      rebateBalance: '返利结余',
      isBaiLian: '百炼转换',
      monthRange: '月份范围',
      visitTheme: '当日拜访主题'
    },
    table: {
      customerNumber: '客户编号',
      storeName: '店名',
      RTMType: 'RTM类型',
      retailStoreCategory: '零售店类别',
      province: '省',
      city: '市',
      area: '区',
      address: '地址',
      SRNO: 'SR工号',
      SRName: 'SR姓名',
      TTPSigningVolumeGY: '固特异TPP',
      TTPSigningVolumeCP: '固铂TPP',
      rebateBalance: '返利结余',
      lastPurchaseTime: '最近一次RTM下单时间',
      lastVisitTime: '最近一次拜访日期',
      visitFrequency: '当月拜访次数',
      contract: '是否参与天猫/京东',
      shopBrandType: '店招品牌类型',
      gasnFlag: 'GASN门店签约情况',
      pointBalance: '积分结余',
      storeContact: '联系人',
      action: '操作'
    }
  },
  DAStoreList: {
    common: {
      selectHolder: '请选择',
      exportText: '零售商与SR关系'
    },
    BoxWrap: {
      manage: '零售商与SR关系查询',
      list: '零售商与SR关系列表'
    },
    form: {
      customerNumber: '客户编号',
      storeName: '店名',
      RTMType: 'RTM类型',
      retailStoreCategory: '零售店类别',
      provinceCityDistrict: '省市区',
      province: '省',
      city: '市',
      area: '区',
      address: '地址',
      SRNO: 'SR工号',
      SRName: 'SR姓名',
      spFullName: '服务商',
      cascaderPlaceholder: '请选择所在地区'
    },
    table: {
      sequence: '序号',
      customerNumber: '客户编号',
      storeName: '店名',
      RTMType: 'RTM类型',
      retailStoreCategory: '零售店类别',
      province: '省',
      city: '市',
      area: '区',
      address: '地址',
      SRNO: 'SR工号',
      SRName: 'SR姓名',
      spFullName: '服务商',
      remarkOne: '分类1',
      remarkTwo: '分类2',
      remarkThree: '分类3',
      action: '操作'
    }
  },
  storeVisitReport: {
    common: {
      project: '店内服务项目',
      point: '百分比',
      basicInfo: '基本信息',
      moreInfo: '更多信息',
      RSSAS: '零售店性质和人员情况',
      storeSInfo: '店招信息附店招照片',
      storeMS: '店内主要服务项目',
      facAEq: '店内设施设备',
      otherMsg: '其他参考信息',
      uploadPhotoTip: '只能上传jpg/png文件，且不超过500kb',
      saveReportSuccess: '报告保存成功，即将返回列表',
      submitTip: '一旦提交报告不可以修改，确认是否提交',
      submit: '提交',
      disSubmit: '不提交'
    },
    step: {
      RSInfo: '零售店信息',
      sales: '销售情况',
      TPPRecords: 'TPP记录',
      salesRecord: '零售店KPI',
      trainingRecord: '培训记录',
      visitorRecord: '访店记录'
    },
    basic: {
      retailStoreRTMCategory: '零售店RTM类型',
      retailStoreCategory: '零售店类别',
      retailStoreCategoryDesc: '零售店类别描述',
      customerNumber: '客户编号',
      storeName: '店名',
      address: '地址',
      provinceCityDistrict: '省市区',
      province: '省',
      city: '市',
      area: '区',
      telPhone: '电话',
      contact1: '联系人1',
      cellPhone1: '手机号1'
    },
    more: {
      contact2: '联系人2',
      cellPhone2: '手机号2',
      contact3: '联系人3',
      cellPhone3: '手机号3',
      customerCreationDate: '客户创建日期',
      empNo: 'SR工号',
      empName: 'SR姓名',
      category1: '分类1',
      category2: '分类2',
      category3: '分类3',
      serviceProvider: '服务商'
    },
    RSSAS: {
      carTRHistory: '从事轿车轮胎零售历史 (年)',
      carTAForTotal: '轿车轮胎占总业务量',
      AvMSalesOfTires: '轮胎月均总销量',
      RSS: '零售店性质',
      employeeCount: '员工数',
      retailShare: '零售业务占比',
      maxSalesBrand: '销量最大品牌',
      maxSalesQty: '最大品牌月度销量',
      gySalesQty: '固特异月度销量'
    },
    storeSInfo: {
      shopSignBrand: '店招品牌',
      otherBrands: '其他品牌',
      installationDate: '安装日期',
      expiryDate: '到期日期',
      employeeCount: '员工数',
      storefrontPic: '门头照片',
      displayPic1: '陈列照片1',
      displayPic2: '陈列照片2',
      siMain: '主要服务项目',
      siMainPercentage: '主要服务项目占比(营业额)'
    },
    storeMS: {
      tire: '轮胎',
      nonTire: '非轮胎',
      maintainance: '保养',
      quickFix: '快修',
      cosmetic: '美容',
      washCar: '洗车',
      otherService: '其他服务项目',
      siBalance: '动平衡',
      siWheelPosition: '四轮定位',
      siTireRepair: '补胎',
      siValve: '气门嘴',
      siEngineOil: '机油',
      siBrake: '刹车',
      siBattery: '电瓶',
      siFacialClean: '洗美',
      siPerishableGoods: '易耗品'
    },
    facAEq: {
      area: '店面积',
      stationsCount: '轮胎快修相关工位数',
      accountingMethod: '记账方式',
      instoreFac: '店内设施',
      toilet: '洗手间',
      customerLounge: '客户休息室',
      wheelAlignment: '四轮定位',
      tireMachine: '装拆胎机',
      DBMachine: '动平衡机',
      liftMachine: '举升机'
    },
    otherMsg: {
      pointBalance: '积分结余',
      rebateBalance: '返利结余',
      visitFrequency: '当月拜访次数',
      contract: '是否参与天猫/京东',
      contractTM: '是否参与天猫',
      contractJD: '是否参与京东',
      lastVisitTime: '最近一次拜访日期',
      lastPurchaseTime: '飞足e购最近一次下单时间'
    },
    SSTable: {
      tireBrand: '轮胎品牌',
      mainChannel: '主要进货渠道',
      payway: '结款方式',
      AMSales: '月均销量',
      stock: '库存',
      sum: '求和',
      storeMIX: '门店18+MIX',
      updateTime: '更新时间',
      msg1: '请至少填写一项'
    },
    SStatistic: {
      AvMSalesOfTires: '轮胎月均总销量',
      stockTotal: '总库存',
      updateTime: '更新日期'
    },
    TPPRCommon: {
      changeLog: '变更记录',
      TPPInfo: 'TPP签约量'
    },
    // TPPRTable: {
    //   contractStatus: '签约状态',
    //   RTMTypeold: 'RTM Type old',
    //   RTMTypenew: 'RTM Type new',
    //   RetailerTypeold: 'Retailer Type old',
    //   RetailerTypenew: 'Retailer Type new',
    //   GYTPPvolumeold: 'GY TPP volume old',
    //   year: '年份',
    //   brand: '品牌',
    //   January: '1月',
    //   February: '2月',
    //   March: '3月',
    //   April: '4月',
    //   May: '5月',
    //   June: '6月',
    //   July: '7月',
    //   August: '8月',
    //   September: '9月',
    //   October: '10月',
    //   November: '11月',
    //   December: '12月'
    // },
    SRecord: {
      monthly: '月度',
      quarter: '季度',
      year: '年度'
    },
    TRForm: {
      TRContent: '培训内容',
      TRDate: '培训日期',
      TRWay: '培训方式',
      TRAddress: '培训地点',
      trainer: '培训导师',
      trainee: '被培训人',
      GYTComments: '固特异培训导师评语',
      effAchieved: '效果达成',
      nexTPlan: '下次培训计划'
    },
    VRForm: {
      VRDate: '日期',
      participants: '与会者',
      startTime: '开始时间',
      endTime: '结束时间',
      destination1: '拜访目的1',
      destination2: '拜访目的2',
      issue1: '议题1',
      detailDesc1: '细节描述1',
      issue2: '议题2',
      detailDesc2: '细节描述2',
      issue3: '议题3',
      detailDesc3: '细节描述3',
      issue4: '议题4',
      detailDesc4: '细节描述4',
      followMatter1: '跟进事项1',
      followDeadline1: '跟进截止日1',
      followMatter2: '跟进事项2',
      followDeadline2: '跟进截止日2',
      followMatter3: '跟进事项3',
      followDeadline3: '跟进截止日3',
      photoFile: '照片文件',
      others: '检查表',
      feedback: '任务分配执行反馈',
      feedback_other_task: '任务描述'
    },
    recordFeedback: {
      subTitle1: '合作意向反馈',
      subTitle2: '门店意见反馈',
      acceptTerms: '是否必须要有账期才会合作',
      willingToRtmOrder: '是否愿意下载飞足e购APP来订购固特异轮胎',
      urgentDeliveryTime: '紧急订单期望物流时效',
      regularDeliveryTime: '常规订单期望物流时效',
      evaluateRate: '门店潜力评分',
      goodContent: '正面评价',
      badContent: '反面评价',
      otherContent: '其他评价'
    },
    errMsg: {
      photos: '请上传至少一张照片',
      checkList: '请在检查表中至少选择一个选项',
      evaluateRate: '请给门店的潜力评分',
      contentList: '请至少选择或输入一项评价',
      otherContentList: '请输入其他评价的内容',
      otherTaskDescription: '请输入任务描述'
    }
  },
  retailStoresInfo: {
    common: {
      back: '返回'
    },
    title: {
      storeName: '店名'
    },
    input: {
      inputHolder: '请输入',
      dataHolder: '请选择日期',
      selectHolder: '请选择'
    },
    error: {
      validPhone: '请输入合法的手机号码',
      name: '请输入合法的名称',
      float: '请输入合法的数值',
      patt: '请输入合法的数值,支持2位小数百分数',
      stringLength: '请输入合法的数值',
      sn: '请输入合法的数字'
    },
    form: {
      baseInfo: {
        title: '基本信息',
        customerCode: '客户编号',
        storeName: '店名',
        retailerRTMCategory: '零售店RTM类型',
        retailerCategory: '零售店类别',
        retailerCategoryDescription: '零售店类别描述',
        province: '省',
        city: '市',
        district: '区',
        address: '地址',
        contacts1: '联系人1',
        mobile: '手机号1',
        visitFrequency: '当月拜访次数',
        pointBalance: '积分结余',
        rebateBalance: '返利结余',
        lastPurchaseTime: '最近一次RTM下单时间',
        lastStartTime: '最近一次拜访日期'
      },
      moreInfo: {
        title: '更多信息',
        contact2: '联系人2',
        mobile2: '手机号2',
        contact3: '联系人3',
        mobile3: '手机号3',
        customerCreationTime: '客户创建日期',
        empNo: 'SR工号',
        empName: 'SR姓名',
        serviceProvince: '服务商',
        remark1: '分类1',
        remark2: '分类2',
        remark3: '分类3'
      },
      storeArchSit: {
        title: '零售店性质和人员情况',
        experienceYear: '从事轿车轮胎零售历史 (年)',
        businessVolume: '轿车轮胎占总业务量',
        monSalesVolume: '轮胎月均总销量',
        retailStoreStructure: '零售店性质',
        emNum: '员工数',
        retailShare: '零售业务占比',
        maxSalesBrand: '销量最大品牌',
        maxSalesQty: '最大品牌月度销量',
        gySalesQty: '固特异月度销量'
      },
      storeInfoPic: {
        title: '店招信息附店招照片',
        storeSignBrand: '店招品牌',
        otherBrands: '其他品牌',
        installationDate: '安装日期',
        expDate: '到期日期',
        storefrontPic: '门头照片',
        displayPic1: '陈列照片1',
        displayPic2: '陈列照片2'
      },
      mainServicesInStore: {
        title: '店内主要服务项目',
        serviceItem: '店内服务项目',
        otherItem: '其他服务项目',
        mainItem: '主要服务项目',
        busVolume: '主要服务项目占比(营业额)'
      },
      storeFacEqu: {
        tire: '轮胎',
        nonTire: '非轮胎',
        title: '店内设施设备',
        storeArea: '店面积(㎡)',
        worksNum: '轮胎快修相关工位数',
        accountMethod: '记账方式',
        storeFac: '店内设施',
        siTire: '轮胎',
        siMaintainence: '保养',
        siFastRepair: '快修',
        siBeauty: '美容',
        siWashing: '洗车',
        siBalance: '动平衡',
        siWheelPosition: '四轮定位',
        siTireRepair: '补胎',
        siValve: '气门嘴',
        siEngineOil: '机油',
        siBrake: '刹车',
        siBattery: '电瓶',
        siFacialClean: '洗美',
        siPerishableGoods: '易耗品',
        laundry: '洗手间 ',
        restRoom: '客户休息室',
        alignment: '四轮定位',
        fitting: '装拆胎机',
        balancing: '动平衡机'
      },
      otherBrandSales: {
        systemPk: '序号',
        title: '销售情况',
        brand: '轮胎品牌',
        tireSupplier: '主要进货渠道',
        paymentTerms: '结款方式',
        monthlyAvgSales: '月均销量',
        stock: '库存',
        tyreEighteenGreater: '门店18+MIX',
        updateTime: '更新日期'
      },
      ttpSignAesc: {
        systemPk: '序号',
        title: 'TPP记录',
        signingStatus: '签约状态',
        RTMOldType: 'RTM Type old',
        RTMNewType: 'RTM Type new',
        stoOldType: 'Retailer Type old',
        stoNewType: 'Retailer Type new',
        GYOldSign: 'GY TPP volume old',
        GYNewSign: 'GY TPP volume new',
        CPOldSign: 'CP TPP volume old',
        CPNewSign: 'CP TPP volume new',
        effectiveDate: '生效年月',
        createTime: '创建日期',
        updateTime: '更新日期'
      },
      model: {
        salesKPI: '零售店KPI',
        visitStoRecord: '访店记录',
        trainRecord: '培训记录'
      },
      otherRecord: {
        title: '其他参考信息',
        pointBalance: '积分结余',
        rebateBalance: '返利结余',
        visitFrequency: '当月拜访次数',
        contract: '是否参与天猫/京东',
        contractTM: '是否参与天猫',
        contractJD: '是否参与京东',
        lastVisitTime: '最近一次拜访日期',
        lastPurchaseTime: '飞足e购最近一次下单时间'
      },
      product: {
        common: {
          title: '产品信息'
        },
        input: {
          vehicleType: '车型',
          rimSize: '轮毂尺寸',
          pattern: '花纹',
          specification: '规格'
        },
        table: {
          productCode: 'SAP编号',
          productName: '产品名称',
          isLongTailProduct: '是否长尾产品',
          rimSize: '轮毂尺寸',
          productPrice: '原价(含税)',
          productPriceTax: '下单价(含税)',
          regularProductStockAllowance: '常规产品库存余量',
          longTailProductStock: '长尾产品库存'
        },
        error: {
          specification: '规格查询关键字数不能少于5个'
        }
      },
      year: {
        brand: '品牌',
        january: '一月',
        february: '二月',
        march: '三月',
        april: '四月',
        may: '五月',
        june: '六月',
        july: '七月',
        august: '八月',
        september: '九月',
        october: '十月',
        november: '十一月',
        december: '十二月'
      }
    }
  },
  visitRecord: {
    title: {
      text: '检查表'
    },
    table: {
      systemPk: '序号',
      date: '日期',
      startTime: '开始时间',
      endTime: '结束时间',
      visitPurpose1: '拜访目的1',
      visitPurpose2: '拜访目的2',
      participant: '与会者',
      topics1: '议题1',
      desDetailed1: '细节描述1',
      topics2: '议题2',
      desDetailed2: '细节描述2',
      topics3: '议题3',
      desDetailed3: '细节描述3',
      topics4: '议题4',
      desDetailed4: '细节描述4',
      followUpMatters1: '跟进事项1',
      followUpDeadline1: '跟进截止日1',
      followUpMatters2: '跟进事项2',
      followUpDeadline2: '跟进截止日2',
      followUpMatters3: '跟进事项3',
      followUpDeadline3: '跟进截止日3',
      comBusPol: '沟通商务政策',
      priceAnalysisCom: '价格分析对比',
      isOrderCom: '是否订单推荐与获取',
      isTrain: '是否培训',
      isStockCheck: '是否库存盘点',
      isFeizuEPurchase: '是否飞足e购注册',
      isGetBusPol: '是否获取商务政策和市场信息',
      isPushQuestionnaire: '是否填写定期推送的问卷',
      action: '图片/文件'
    }
  },
  enote: {
    title: {
      enote: 'ENOTE'
    },
    content: {
      noData: '暂无数据'
    }
  },
  trainingRecords: {
    table: {
      systemPk: '序号',
      trainingCourse: '培训内容',
      trainingDate: '培训日期',
      trainingLocation: '培训地点',
      trainer: '培训导师',
      trainee: '被培人',
      trainingChannel: '培训方式',
      gyTrainerComments: '固特异培训导师评语',
      trainingAchievement: '效果达成',
      nextTrainingPlan: '下次培训计划'
    }
  },
  salesKPIManagement: {
    BoxWrap: {
      manage: '销量KPI查询',
      list: '销量KPI列表'
    },
    common: {
      exportText: '销量KPI管理'
    },
    form: {
      rsmEmpNo: 'Region Head工号',
      rsmEmpName: 'Region Head姓名',
      asmEmpNo: 'ASM工号',
      asmEmpName: 'ASM姓名',
      empNo: 'SR工号',
      empName: 'SR姓名',
      brand: '品牌',
      year: '年份'
    },
    table: {
      rsmEmpNo: 'Region Head工号',
      rsmEmpName: 'Region Head姓名',
      asmEmpNo: 'ASM工号',
      asmEmpName: 'ASM姓名',
      empNo: 'SR工号',
      empName: 'SR姓名',
      brand: '品牌',
      year: '年份',
      JanuaryTargetSales: '1月目标销量',
      January17TargetSales: '1月17+目标销量',
      January18TargetSales: '1月18+目标销量',
      FebruaryTargetSales: '2月目标销量',
      February17TargetSales: '2月17+目标销量',
      February18TargetSales: '2月18+目标销量',
      MarchTargetSales: '3月目标销量',
      March17TargetSales: '3月17+目标销量',
      March18TargetSales: '3月18+目标销量',
      AprilTargetSales: '4月目标销量',
      April17TargetSales: '4月17+目标销量',
      April18TargetSales: '4月18+目标销量',
      MayTargetSales: '5月目标销量',
      May17TargetSales: '5月17+目标销量',
      May18TargetSales: '5月18+目标销量',
      JuneTargetSales: '6月目标销量',
      June17TargetSales: '6月17+目标销量',
      June18TargetSales: '6月18+目标销量',
      JulyTargetSales: '7月目标销量',
      July17TargetSales: '7月17+目标销量',
      July18TargetSales: '7月18+目标销量',
      AugustTargetSales: '8月目标销量',
      August17TargetSales: '8月17+目标销量',
      August18TargetSales: '8月18+目标销量',
      SeptemberTargetSales: '9月目标销量',
      September17TargetSales: '9月17+目标销量',
      September18TargetSales: '9月18+目标销量',
      OctoberTargetSales: '10月目标销量',
      October17TargetSales: '10月17+目标销量',
      October18TargetSales: '10月18+目标销量',
      NovemberTargetSales: '11月目标销量',
      November17TargetSales: '11月17+目标销量',
      November18TargetSales: '11月18+目标销量',
      DecemberTargetSales: '12月目标销量',
      December17TargetSales: '12月17+目标销量',
      December18TargetSales: '12月18+目标销量'
    }
  },
  contractKPIManagement: {
    BoxWrap: {
      manage: '签约KPI查询',
      list: '签约KPI列表'
    },
    common: {
      exportText: '签约KPI管理'
    },
    form: {
      rsmEmpNo: 'Region Head工号',
      rsmEmpName: 'Region Head姓名',
      asmEmpNo: 'ASM工号',
      asmEmpName: 'ASM姓名',
      empNo: 'SR工号',
      empName: 'SR姓名',
      year: '年份'
    },
    table: {
      rsmEmpNo: 'Region Head工号',
      rsmEmpName: 'Region Head姓名',
      asmEmpNo: 'ASM工号',
      asmEmpName: 'ASM姓名',
      empNo: 'SR工号',
      empName: 'SR姓名',
      year: '年份',
      oneSigningTargetQty: '1月签约店目标',
      oneActiveTargetQty: '1月活跃店家目标数',
      twoSigningTargetQty: '2月签约店目标',
      twoActiveTargetQty: '2月活跃店家目标数',
      threeSigningTargetQty: '3月签约店目标',
      threeActiveTargetQty: '3月活跃店家目标数',
      fourSigningTargetQty: '4月签约店目标',
      fourActiveTargetQty: '4月活跃店家目标数',
      fiveSigningTargetQty: '5月签约店目标',
      fiveActiveTargetQty: '5月活跃店家目标数',
      sixSigningTargetQty: '6月签约店目标',
      sixActiveTargetQty: '6月活跃店家目标数',
      sevenSigningTargetQty: '7月签约店目标',
      sevenActiveTargetQty: '7月活跃店家目标数',
      eightSigningTargetQty: '8月签约店目标',
      eightActiveTargetQty: '8月活跃店家目标数',
      nineSigningTargetQty: '9月签约店目标',
      nineActiveTargetQty: '9月活跃店家目标数',
      tenSigningTargetQty: '10月签约店目标',
      tenActiveTargetQty: '10月活跃店家目标数',
      elevenSigningTargetQty: '11月签约店目标',
      elevenActiveTargetQty: '11月活跃店家目标数',
      twelveSigningTargetQty: '12月签约店目标',
      twelveActiveTargetQty: '12月活跃店家目标数'
    }
  },
  storeComponents: {
    common: {
      pleaseSelectMonth: '请选择月份',
      pleaseSelectQuarter: '请选择或输入季度',
      pleaseSelectYear: '请选择年份',
      targetSalesMonth: '本月目标销量',
      numberOfOrders: '下单条数',
      numberOfConfirmations: '确认收货条数',
      desc1: '统计数据为“历史全月”或“当月开始日至昨日”数据',
      desc2: '统计数据为“季度全季”或“当季开始日至昨日”数据',
      desc3: '统计数据为本年度开始至昨日',
      comment: '评论',
      task: '分配任务'
    },
    title: {
      sales: '销量',
      saleDisplay: '销售表现',
      store: '目标- 门店相关',
      order: '目标- 订单相关',
      visitReport: '月度拜访报告',
      visitReportTitle: '拜访报告/拜访天数',
      TPP: 'TPP达成量',
      monthlyActualSales: '月度实际销售情况',
      quarterActualSales: '季度实际销售情况',
      orderStatus: '订单情况',
      tppRate: 'TPP达成率',
      tppCount: 'TPP达成量',
      tppUnfinishCount: 'TPP未达成量',
      finishRate: '已完成占比',
      totalSales: '总销量',
      unfinishSales: '未完成量',
      GY: '固特异',
      CP: '固铂',
      tppSignNum: '固特异TPP签约店数（当月）',
      tppActiveNum: '固特异活跃TPP店家数（当月）',
      tppActiveNumQuarter: '固特异活跃TPP店家数（当季）',
      item1: '家',
      item2: '条',
      item3: '天',
      shop: '门店'
    },
    table: {
      col1: 'MIX',
      col2: '目标量',
      col3: '已完成/未完成',
      col4: '完成率',
      row1: '总销量'
    },
    tab: {
      month: '月度',
      quarter: '季度',
      year: '年度',
      sales: '销量',
      money: '金额',
      score: '积分',
      store: '门店'
    },
    select: {
      brand: '品牌',
      month: '月度',
      quarter: '季度',
      year: '年度'
    },
    form: {
      brand: '品牌',
      month: '月度',
      quarter: '季度',
      year: '年度'
    },
    charts: {
      total: '总量'
    }
  },
  taskScheduleLog: {
    BoxWrap: {
      manage: '定时任务日志查询',
      list: '定时任务日志列表'
    },
    input: {
      taskJobName: '定时任务名称',
      taskSchedulerJobPk: '定时任务编号',
      result: '结果',
      time: '时间范围',
      inputHolder: '请输入',
      dataHolder: '请选择日期',
      selectHolder: '请选择'
    },
    table: {
      sequence: '序号',
      taskSchedulerJobPk: '定时任务编号',
      taskJobName: '定时任务名称',
      result: '结果',
      errorMsg: '错误信息',
      executeSec: '执行时间(ms)',
      createTime: '创建时间',
      lastUpdateTime: '最后更新时间',
      action: '操作'
    },
    message: {
      success: '执行成功',
      error: '执行失败'
    }
  },
  dashboard: {
    GY: '固特异',
    CP: '固铂',
    achievementRate: '达成率',
    underachievedQuat: '未达成量',
    ECharts_actual: '总销量',
    newProduct: '新产品销量',
    activeStoreTarget: '活跃店数/活跃店目标',
    signStoreTarget: '签约店数/签约店目标',
    sortNum: '排名',
    salesNumber: '实际销量',
    spName: 'SP名称',
    monthRegistered: '月度注册门店',
    annuallyRegistered: '年度注册门店',
    allRegistered: '总注册门店',
    timeVar: '时间维度',
    integral: '积分',
    revenueAmount: '销售金额',
    revenueAverage: '平均单价',
    integralTarget: '目标',
    integralTarget2: '目标',
    revenueTarget: '销量金额目标',
    revenueTarget2: '目标',
    revenuePreTire: '单胎销售金额',
    grossMargin: '毛利',
    grossMarginTarget: '毛利目标',
    grossMarginPreTire: '单胎毛利',
    revenueTip: '所有销售金额均不含税，其中返利金额为预估，仅供参考，最终金额以财务结算为准。',
    storeTip: '活跃店：当月有确认收货的零售店。',
    storeAllTip: '活跃店：当月和上月均有确认收货。',
    bonus: {
      title: '当季奖金试算',
      button: '试算',
      salary: '月薪',
      bonus: '奖金',
      bonusMonth: '奖金系数',
      tip: '以上试算只考虑销量积分部分，暂未包含建店积分，数值仅供参考，最终奖金金额以人事部门核算为准。'
    },
    filter: {
      specification: '规格',
      specificationPlaceHolder: '输入轮胎',
      sp: 'SP',
      spPlaceHolder: '输入服务商名称',
      asm: 'ASM',
      asmPlaceHolder: '输入ASM名称',
      sr: 'SR',
      srPlaceHolder: '输入SR名称'
    },
    commentSuccess: '您的点赞或评论已发送',
    excellent: '优秀',
    goodJob: '干得好！',
    perfect: '完美',
    pleaseSelect: '请选择',
    asrSort: 'ASM排名',
    srSort: 'SR排名',
    spSort: 'SP排名',
    commentInfo: '您如何评价选中员工的表现？',
    commentInfoConfirm: '您确定要取消选择',
    hasChoose: '您已选择',
    mix: 'MIX 销量',
    target: '战略产品销量',
    pleaseComment: '请留下评论',
    order: '订单',
    orderTarget_confirmedQty: '确认收货条数',
    commentDialogTitle: '评论',
    saleDisplayForTab: '销售表现',
    comment_hintText: '有什么要添加的吗？',
    spBatchCommentDesc: '您如何评价负责选中的 {quat} 个区域的员工的表现?',
    asmBatchCommentDesc: '您如何评价选中的 {quat} 个员工的表现?',
    srBatchCommentDesc: '您如何评价选中的 {quat} 个员工的表现?',
    salesReport: '销售报表'
  },
  // 任务分配
  assignTasks: {
    DialogTitle: '分配任务',
    SR: 'SR',
    taskFromType: '任务来源类型',
    taskType: '任务类型',
    rtlRtmCategory: 'RTM类型',
    retailerType: '零售店类型',
    storeAddress: '省市区',
    retailorStore: '选择门店',
    createName: '分配人',
    nowTime: '任务分配日期',
    signBoardBidFlag: '竞品店招',
    visitPurpose: '拜访目的',
    dueTime: '截止日期',
    remark: '备注',
    sendSuccess: '发送成功',
    table: {
      storeCode: '门店编号',
      storeName: '门店名称',
      storeAddress: '门店地址',
      contactor: '联系人'
    }
  },
  Chatbot: {
    Chatbot: 'Chatbot',
    Chatbot_knowledge_base: '知识库',
    Chatbot_behavior_analysis: '访店分析',
    copy_success: '复制成功',
    copy_failed: '复制失败',
    chatbot_feedback: '感谢您的反馈！',
    chatbot_dialog: '对话',
    chatbot_rebuild_failed: '重新生成失败',
    Chatbot_input_placeholder: '请输入您想咨询的问题',
    Chatbot_tips: '猜你想问'
  },
  salesReport: {
    BoxWrap: {
      manage: '销售详情查询',
      list: '销售详情列表'
    },
    common: {
      exportText: '销售详情管理',
      submitSuccess: '提交成功',
      submitFail: '提交失败',
      success: '操作成功',
      fail: '操作失败',
      warning: '请填写所有数据',
      lastUpdateTime: '最后销量刷新时间',
      unSubmit: '待提交',
      submit: '提交',
      edit: '修改',
      cancel: '取消'
    },
    form: {
      spName: '服务商名称',
      asmEmpNo: 'ASM',
      rsmEmpNo: 'Region Head'
    },
    table: {
      asmEmp: 'ASM',
      rsmEmp: 'Region Head',
      spName: '服务商名称',
      auditStatus: '状态',
      orderQty: 'MTD零售店订单数量',
      deliverQty: 'MTD服务商确认数量',
      receiptQty: 'MTD门店确认收货数量',
      salesTargetQty: '本月SOP',
      emeWeekTotalQty: '本月总EME',
      emeWeekOneQty: 'Week1 EME',
      emeWeekTwoQty: 'Week2 EME',
      emeWeekThreeQty: 'Week3 EME',
      emeWeekFourQty: 'Week4 EME',
      emeWeekFiveQty: 'Week5 EME',
      emeWeekChangeQty: '机会',
      action: '操作',
      approve: '通过',
      reject: '不通过'
    }
  },
  oilAllowance: {
    BoxWrap: {
      manage: '油费津贴查询',
      list: '油费津贴列表'
    },
    common: {
      exportText: '油费津贴',
      exportDetailText: '油费津贴明细',
      exportCarSubsidyText: '车补行程单'
    },
    form: {
      empNo: '工号',
      empName: '姓名',
      status: '状态',
      date: '日期'
    },
    table: {
      signRecordNo: '油补编号',
      dateCycle: '日期周期',
      dayFormatted: '日期',
      empNo: '工号',
      empName: '姓名',
      estimateDistance: '预估里程',
      estimateAllowance: '预估津贴',
      status: '状态',
      action: '操作'
    },
    table2: {
      planTaskDate: '日期',
      empNo: '工号',
      empName: '姓名',
      planTaskTime: '计划时间',
      actualPlanTaskTime: '任务时间',
      planTaskType: '任务类型',
      category: '类型',
      rtlSapId: '门店编号',
      rtlFullName: '门店名称',
      checkInDateTime: '打卡时间',
      checkInAddress: '打卡地点',
      driveType: '出行方式',
      driveRemark: '出行备注',
      signType: '签到状态',
      auditRemark: '审批状态'
    },
    table3: {
      auditName: '审批人',
      auditTime: '审批时间',
      auditStatus: '审批状态',
      refuseReason: '审批意见'
    }
  },
  mealAllowance: {
    BoxWrap: {
      manage: '餐费津贴查询',
      list: '餐费津贴列表'
    },
    common: {
      exportText: '餐费津贴',
      exportMealSupplementText: '餐补统计'
    },
    form: {
      empNo: '工号',
      empName: '姓名',
      status: '状态',
      date: '日期',
      teamType: '团队',
      optionPlaceholder: '请选择'
    },
    table: {
      signRecordNo: '餐补编号',
      dateCycle: '日期周期',
      dayFormatted: '日期',
      empNo: '工号',
      empName: '姓名',
      planTaskType: '工作类型记录',
      combineAddress: '常住地',
      combineCheckInAddress: '最后任务打卡地点',
      taskCheckInDatetime: '最后任务打卡时间',
      checkInDatetime: '最晚打卡时间',
      totalMeal: '预估津贴',
      mealRemark: '餐补备注',
      action: '操作'
    }
  }
};